<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ invalid }"
  >
    <ModalConfirmation
      shouldCloseOnBlur
      :showModal="isEditing"
      :title="headerText"
      @cancel="handleCancel"
    >
      <template v-slot:body>
        <InputText
          v-model="nameValue"
          :autofocus="true"
          :class="$style.input"
          label="Display Name"
          name="Display Name"
          rules="max:255"
        />
      </template>
      <template v-slot:footer>
        <ButtonGroupSave
          :isDisabledPrimary="invalid"
          :isFullWidth="false"
          @primaryAction="handleSave"
          @secondaryAction="handleCancel"
        />
      </template>
    </ModalConfirmation>
  </ValidationObserver>
</template>

<script>
import { ButtonGroupSave, InputText, ModalConfirmation } from '@jumpcloud/ui-components';
import { ValidationObserver } from 'vee-validate3';

export default {
  name: 'EditableNameModal',

  components: {
    ButtonGroupSave,
    InputText,
    ModalConfirmation,
    ValidationObserver,
  },

  props: {
    headerText: {
      type: String,
      required: true,
    },
    initialName: {
      type: String,
      required: true,
    },
    isEditing: Boolean,
  },

  data() {
    return {
      nameValue: this.initialName,
    };
  },

  methods: {
    handleCancel() {
      this.nameValue = this.initialName;
      this.$emit('close');
    },

    handleSave() {
      this.$emit('save', this.nameValue);
      this.$emit('close');
    },
  },
};
</script>

<style module>
.input {
  padding: var(--jc-spacer-x-small) 0;
}
</style>
